export default (input) =>
  btoa(input).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
